<div
  class="carousel"
  *ngIf="images.length">

  <div
  class="banner-search"
  *ngIf="showMobileSearch"
>

<input
  type="text"
  [(ngModel)]="searchText"
  (input)="applySearch()"
  placeholder="{{ t('searchProducts') }}"
/>

</div>

  <button
    class="nav prev"
    (click)="prev()">

    ❮

  </button>

  <img
    [src]="images[current]"
    alt="Banner">

  <button
    class="nav next"
    (click)="next()">

    ❯

  </button>

</div>